module.exports = function getResource(label, vars = []) {
    let resources = {
        departments: 'Services'
    };
    return resources[label];
};
